exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/shared/components/get-date-dialog/get-date-dialog.component.css
// module id = ../../../../../src/app/shared/components/get-date-dialog/get-date-dialog.component.css
// module chunks = main